import React from "react";
import Typography from "@material-ui/core/Typography";
import { withTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import PouleTable from "./PouleTable";

class PouleResults extends React.Component {
  render() {
    return (
      <Paper
        style={{
          marginBottom: 15,
          width: 650,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: this.props.theme.palette.primary.main,
            display: "flex",
            alignItems: "center",
            height: 30,
            paddingLeft: 10,
          }}
        >
          <Typography
            variant="body2"
            style={{ color: "white", fontWeight: 500 }}
          >
            {this.props.poule.name}
          </Typography>
        </div>

        <PouleTable
          tournament={this.props.tournament}
          selectedPoule={this.props.poule.id}
          poulesByKey={this.props.poulesByKey}
          matches={this.props.matches}
          teams={this.props.teams}
          pouleResults={this.props.pouleResults}
        />
      </Paper>
    );
  }
}

export default withTheme(PouleResults);
